import { render, staticRenderFns } from "./win.vue?vue&type=template&id=6d0f5364&scoped=true&"
import script from "./win.vue?vue&type=script&lang=js&"
export * from "./win.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f5364",
  null
  
)

export default component.exports